import React from 'react';
import PropTypes from 'prop-types';
import renderHtml from 'react-render-html';
import ModalContainer from '../../Global/Modals/ModalContainer';
import ConfirmModal from '../../Global/Modals/ConfirmModal';

const RemoveLicenceModal = ({ modalIsOpen, loading, onConfirmClick, onCloseClick, licencee }) => {
  let firstName;
  let lastName;
  let licenceType;

  // Have to do this as on page load the licencee prop is an empty object, it only become populated once the user hits the delete button
  if ('attributes' in licencee) {
    firstName = licencee.attributes['first-name'];
    lastName = licencee.attributes['last-name'];
    licenceType = licencee.attributes['licence-type'];
  }

  return (
    <ModalContainer
      isOpen={modalIsOpen}
      closeModal={onCloseClick}
      label="Remove Licence modal"
    >
      <ConfirmModal
        loading={loading}
        title="Are you sure?"
        confirmText="Remove licence"
        onConfirmClick={onConfirmClick}
        onCloseClick={onCloseClick}
      >
        <p>{renderHtml(`Are you sure you want to remove this <span className="fw-medium text-capitalize">${licenceType}</span> licence from <span className="fw-medium">${firstName} ${lastName}</span>?`)}</p>
      </ConfirmModal>
    </ModalContainer>
  );
};

RemoveLicenceModal.propTypes = {
  modalIsOpen: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  onConfirmClick: PropTypes.func.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  licencee: PropTypes.object.isRequired,
};

export default RemoveLicenceModal;



// WEBPACK FOOTER //
// ./library/app/components/Account/LicenceManager/RemoveLicenceModal.js